import { render, staticRenderFns } from "./selezionaDistributori.vue?vue&type=template&id=0f46d9ee&"
import script from "./selezionaDistributori.vue.ts?vue&type=script&lang=ts&"
export * from "./selezionaDistributori.vue.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports